import FetcherTableSkeleton from "../FetcherTableSkeleton";

/** Placeholder that mirrors ReportsTable while the catalogue is loading. */
const ReportsSkeleton = () => <FetcherTableSkeleton columns={9} />;

export default ReportsSkeleton;
